// 接口文档：https://test-yapi.supptech.net/project/56/interface/api/2086

import {
  SuggestionList,
  SuggestionListQuery,
  SuggestionReason,
  Suggestion,
  ArchiveSuggestionParams,
} from '@/types/suggestion';
import axiosInstance from './axiosInstance';
import { BaseResponse } from '@/types/common';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

export const getSuggestionReason = async (): Promise<
  BaseResponse<SuggestionReason[]>
> => {
  const resp = await axiosInstance.get<BaseResponse<SuggestionReason[]>>(
    `${baseUrl}/product/feedback/dict`
  );
  return resp.data;
};

export const getSuggestionList = async (
  query: SuggestionListQuery
): Promise<BaseResponse<SuggestionList>> => {
  const resp = await axiosInstance.post<BaseResponse<SuggestionList>>(
    `${baseUrl}/product/feedback/queryPageList?currentPage=${query.currentPage}&pageSize=${query.pageSize}`,
    {
      id: query.id,
      feedbackCode: query.feedbackCode,
      status: query.status,
      createUserId: query.createUserId,
      suppId: query.suppId,
      userNumber: query.suppId,
    }
  );
  return resp.data;
};

export const getSuggestionDetail = async (
  id: string
): Promise<BaseResponse<Suggestion>> => {
  const resp = await axiosInstance.get<BaseResponse<Suggestion>>(
    `${baseUrl}/product/feedback/detail/${id}`
  );
  return resp.data;
};

export const archiveSuggestion = async (
  params: ArchiveSuggestionParams
): Promise<BaseResponse<null>> => {
  const resp = await axiosInstance.post<BaseResponse<null>>(
    `${baseUrl}/product/feedback/submit`,
    params
  );
  return resp.data;
};
